/**
 * @architecture-header 1
 * @layer module-ui
 * @domain settings-subscription
 * @responsibility Render the SET-F08 Subscription pane -- fully static, no session or query needed
 *   since every organization is unconditionally Free (owner ruling).
 * @state-owner none
 * @allowed-imports same-module components
 * @forbidden direct API client; TanStack Query; any new operation
 * @public-api SubscriptionSettingsPage
 * @side-effects none
 * @tests SubscriptionSettingsSurface.test.tsx
 */

import { SubscriptionSettingsSurface } from './SubscriptionSettingsSurface';

export function SubscriptionSettingsPage({ mobile }: { mobile: boolean }) {
  return <SubscriptionSettingsSurface mobile={mobile} />;
}
